import React, { useEffect, useState, } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../../css/home/Home.css';
import { Link } from "react-router-dom";
import message from '../../../data/Message.json';
import TitleDescription from '../../../data/TitleDescription.json';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import { env } from '../../../Services/utils/appMode';
import { AES, enc } from 'crypto-js';
import { useSelector } from 'react-redux';
import { store } from '../../../redux/_helpers/store';
import { success } from '../../../redux/_actions/adminRole.actions';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { profileBaseURL, baseURL, workflowtxnAdmin } from '../../../Services/config/apiGateway';
import { PROFILEAPPROVAL, GETPROXYDETAIL_ENDPOINT } from '../../../Services/config/apiEndPoints';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
toast.configure()
function Home(props) {
  const tile = [
    {
      "imgSrc": require('../../../assets/images/advertisement.svg'),
      "title": "Advertisement",
      "destPage": "/Advertisement",
      "id": 15
    },
    {
      "imgSrc": require('../../../assets/images/announcement.svg'),
      "title": "Announcement",
      "destPage": "/Announcement",
      "id": 22
    },
    {
      "imgSrc": require('../../../assets/images/roleManagement.svg'),
      "title": "Assign Role",
      "destPage": "/AssignRole",
      "id": 12
    },
    // {
    //   "imgSrc": require('../../../assets/images/cancellationPolicy.svg'),
    //   "title": "Cancellation Policy",
    //   "destPage": "/CancellationPolicy",
    //   "id": 24
    // },
    {
      "imgSrc": require('../../../assets/images/createRole.svg'),
      "title": "Create Role",
      "destPage": "/Role",
      "id": 13
    },
    // {
    //   "imgSrc": require('../../../assets/images/manageServices.svg'),
    //   "title": "Manage Services",
    //   "destPage": "/ManageServices",
    //   "id": 27
    // },
    // {
    //   "imgSrc": require('../../../assets/images/preAdvise.svg'),
    //   "title": "Pre-advise",
    //   "destPage": "/PreAdvice",
    //   "id": 11
    // },
    // {
    //   "imgSrc": require('../../../assets/images/subscriptionFees.svg'),
    //   "title": "Subscription Fees",
    //   "destPage": "/SubscriptionFees",
    //   "id": 19
    // },
    {
      "imgSrc": require('../../../assets/images/systemConfig.svg'),
      "title": "System Config",
      "destPage": "/SystemConfig",
      "id": 1
    },
    {
      "imgSrc": require('../../../assets/images/terms&conditions.svg'),
      "title": "Terms & Conditions",
      "destPage": "/TermConditions",
      "id": 16
    },
    // {
    //   "imgSrc": require('../../../assets/images/transactionDiscount.svg'),
    //   "title": "Transaction Discount",
    //   "destPage": "/TransactionFeesDiscount",
    //   "id": 17
    // },
    // {
    //   "imgSrc": require('../../../assets/images/transactionFees.svg'),
    //   "title": "Transaction Fees",
    //   "destPage": "/TransactionFees",
    //   "id": 18
    // },
    // {
    //   "imgSrc": require('../../../assets/images/userProfileApproval.svg'),
    //   "title": "User Profile Approval",
    //   "destPage": "/UserProfile",
    //   "id": 14
    // }
  ]
  const [userData, setUserData] = useState();
  const [proxyData, setProxyData] = useState();
  let selectedTiles = [];
  const roleAssign = useSelector(state => JSON.parse(AES.decrypt(state.authentication.user, 'TPT_CARGO_CONNECT').toString(enc.Utf8)));
  useEffect((index) => {
    if(env === 'Dev'){
    let pendingProxy = [];
    ApiCall(
      'GET',
      profileBaseURL + PROFILEAPPROVAL + "/count",
      {},
      {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    ).then((apiData) => {
      if (apiData.flag !== -1) {
        if (apiData.flag === 500) {
          toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
        }
        else {
          console.log('I am 200!');
          setUserData(apiData.count);
        }
      } else {
        // toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
      }
    });
    ApiCall(
      'GET',
      workflowtxnAdmin + GETPROXYDETAIL_ENDPOINT,
      {},
      {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    ).then((apiData) => {
      if (apiData.flag !== -1) {
        if (apiData.flag === 500) {
          toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
        }
        else {
          console.log('I am 200!');
          apiData.map(x => {
            x.action === "Submitted for Approval" &&
              pendingProxy.push(x)
          }
          )
          setProxyData(pendingProxy.length);
        }
      } else {
        // toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
      }
    });
  }
    // USER HOMEPAGE
    ApiCall(
      'GET',
      baseURL + `users/${roleAssign.userDetails.userdetails.user.userEmail}/roles`,
      {},
      {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    ).then((apiData) => {
      if (apiData.flag !== -1) {
        if (apiData.flag === 500) {
          toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
        }
        else {
          console.log('I am 200!');
          console.log(apiData)
          store.dispatch(success(apiData))
        }
      } else {
        // toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
      }
    });
  }, [])
  // TILE SHOWING THROUGH LOGIN DATA
  // const roleAssign = JSON.parse(AES.decrypt(Cookies.get('TPT_CARGO_CONNECT1_dev'), 'TPT_CARGO_CONNECT').toString(enc.Utf8))
  const isSuperAdmin = roleAssign.userDetails.isSuperAdmin;
  // const role = roleAssign.userDetails.roles.length;
  // //  if(role>0 )
  // //  {
  // //    var assigntile=roleAssign.userDetails.roles[0].permissions
  // //  }
  // // console.log(role, assigntile)
  // if (role > 0) {
  //   tile.map((val, key) => {
  //     for (let c = 0; c < role; c++) {
  //       var assigntile = roleAssign.userDetails.roles[c].permissions
  //       assigntile.find((x, i) => {
  //         if (val.id == x.functionId) {
  //           if (x.method.length > 0) {
  //             selectedTiles.push({
  //               imgSrc: val.imgSrc,
  //               title: x.functionDisplayName,
  //               destPage: val.destPage,
  //             });
  //           }
  //         }
  //       })
  //     }
  //   })
  // }
  // TILE SHOWING THROUGH ROLE DATA
  const roleData = useSelector(state => state.adminRoleReducer.roleData)
  if (roleData != undefined) {
    const roleDataLength = roleData.length;
    // var sampleArr = [];
    if (roleDataLength > 0) {
      tile.map((val, key) => {
        for (let index = 0; index < roleData.length; index++) {
          let assigntile = roleData[index].permissions;

          assigntile.find((functions, i) => {

            if (val.id == functions.functionId) {
              selectedTiles.push({
                imgSrc: val.imgSrc,
                title: functions.functionDisplayName,
                destPage: val.destPage,
                id: functions.functionId
              })
            }
          })
        }
        // BOTH ARE WORKING 

        // var xyz = selectedTiles.filter(function(x){
        //   if(sampleArr.indexOf(x.functionId == -1)){
        //     sampleArr.push(x.functionId)
        //     return true
        //   }
        //   return false
        // })
        // console.log("xyz",xyz)
        selectedTiles = selectedTiles.filter((v, i, a) => a.findIndex(t => (t.id === v.id)) === i)
      })
    }
  }
  return (
    <div className="outer1"><div className="outer1" id="outerdiv1">
      <MetaDecorator title={TitleDescription.homePageTitle} description={TitleDescription.homePageDescription} />
      <div className=" homePage">
        <div class="row" id="boxContainer">
          <div className="actionPendingDiv">
            <>
              <div className="pendingIcon" style={{
                display:
                  // selectedTiles.find(x => x.title == "User Profile Approval") 
                  // || proxyData > 0 
                  selectedTiles.filter(x => x.id == "14" || x.id == "11").length > 0
                    ? "flex" : "none"
              }}></div>
              <p className="actionText" style={{
                display:
                  // selectedTiles.find(x => x.title == "User Profile Approval") 
                  // || proxyData > 0 
                  selectedTiles.filter(x => x.id == "14" || x.id == "11").length > 0
                    ? "flex" : "none"
              }}>Action Pending</p>
            </>
          </div>
          <div className="cardContainer">
            <div
              id="outerCard"
            >
              {/* through API */}

              {
                isSuperAdmin == false ? selectedTiles.map((x, index) =>
                  <Link to={x.destPage}
                    id="tileCard">
                    <div className="pendingActionIcon" style={{
                      display: (x.title == "User Profile Approval" && userData > 0) || (
                        proxyData > 0 &&
                        x.title == "Pre-advise") ? "flex" : "none"
                    }}></div>
                    <div class="mt-4" id="tile" >
                      <div className="tileLink">
                        <img src={x.imgSrc} class="d-inline-block align-top iconsize" alt="" loading="lazy" />
                        <p class="p-1 cardtextname">{x.title}</p>
                      </div>
                    </div>
                  </Link>
                )
                  :
                  tile.map((x, index) => {
                    return <Link to={x.destPage}
                      id="tileCard">
                      <div className="pendingActionIcon" style={{
                        display: (x.title == "User Profile Approval" && userData > 0) || (
                          proxyData > 0 &&
                          x.title == "Pre-advise") ? "flex" : "none"
                      }}></div>
                      <div class="mt-4" id="tile" >
                        <div className="tileLink">
                          <img src={x.imgSrc} class="d-inline-block align-top iconsize" alt="" loading="lazy" />
                          <p class="p-1 cardtextname">{x.title}</p>
                        </div>
                      </div>
                    </Link>
                  }
                  )
              }



              {/* internal json tile */}
              {/* {
                tile.map((x, index) => {
                  return <div
                    id="tileCard">
                    <div className="pendingActionIcon" style={{ display: (x.title == "User Profile Approval" && userData > 0) || (
                      proxyData > 0 &&
                       x.title == "Pre-advise") ? "flex" : "none" }}></div>
                    <div class="mt-4" id="tile" >
                      <Link to={x.destPage} className="tileLink">
                        <img src={x.imgSrc} class="d-inline-block align-top iconsize" alt="" loading="lazy" />
                        <p class="p-1 cardtextname">{x.title}</p>
                      </Link>
                    </div>
                  </div>
                }
                )
              } */}

            </div>
          </div>
        </div>
        <div id="homefooterdiv">
        </div>
      </div>
    </div></div>
  );
}


export default Home;